<po-page-login
  [p-recovery]="this.openPasswordRecoveryModal.bind(this)"
  [p-loading]="buttonLoading"
  p-background="assets/brand/login-background.svg"
  [p-hide-remember-user]="true"
  (p-login-submit)="loginSubmit($event)"
  [p-logo]="(logoUrl$ | async) ?? 'assets/brand/logo-ascensus-positiva.png'"
  p-product-name="GNF - Gestão de Notas Fiscais"
  [p-literals]="loginLiterals"
  [p-hide-password-peek]="false">
</po-page-login>

<!-- Credito de autoria. Fora do po-page-login porque o componente nao expoe
     literal de rodape (ver PoPageLoginLiterals) - so highlightInfo, que e o
     texto grande sobreposto a imagem de destaque. -->
<footer class="gnf-credito">Desenvolvido por TOTVS Santa Catarina</footer>

<po-modal-password-recovery
  #PoModalPasswordRecoveryComponent
  (p-submit)="submitRestorPass($event)"
  [p-type]="recoveryType">
</po-modal-password-recovery>
